var sliderContainer = document.querySelector(".my-slider");

if (sliderContainer) {
    var slider = tns({
        container: sliderContainer,
        items: 2,
        autoplay: false,
        center: true,
        mouseDrag: true,
        loop: false,
        arrowKeys: true,
        nav: false,
        controlsPosition: "bottom",
        controlsContainer: "#custom-control",
        responsive: {
            350: {
                items: 2,
            },
            500: {
                items: 2,
            },
            768: {
                items: 3,
            },
            980: {
                items: 3,
            },
            1280: {
                items: 4,
            },
        },
    });
}

// Flight search results start
class AirportCity {
    constructor(inputElement, searchResultElement) {
        this.searchInput = inputElement;
        this.searchResult = searchResultElement;
        this.inputElementId = $(inputElement).attr("id");
        this.addEvents();
    }

    addEvents() {
        this.searchInput.addEventListener(
            "input",
            this.displayResults.bind(this, this.searchInput)
        );
        this.searchResult.querySelectorAll("li").forEach((item) => {
            item.addEventListener(
                "click",
                this.updateSearchBox.bind(this, item)
            );
        });
    }

    displayResults(inputElement) {
        if (inputElement.value) {
            this.showAddressSearchResults();
        } else {
            this.hideAddressSearchResults();
        }
    }

    showAddressSearchResults() {
        this.searchResult.classList.remove("d-none");
        document.addEventListener(
            "click",
            this.onOutsideClickAddress.bind(this)
        );
    }

    hideAddressSearchResults() {
        this.searchResult.classList.add("d-none");
        document.removeEventListener(
            "click",
            this.onOutsideClickAddress.bind(this)
        );
    }

    onOutsideClickAddress(event) {
        if (event.target === this.searchInput) return;
        if (this.searchResult) this.hideAddressSearchResults();
    }

    updateSearchBox(item) {
        const text = $(item)
            .find(".air-name")
            .clone() //clone the element
            .children() //select all the children
            .remove() //remove all the children
            .end() //again go back to selected element
            .text()
            .trim();
        this.searchInput.value = text;
        this.hideAddressSearchResults();
    }
}

const fromInput = document.getElementById("take-off-location");
const fromResults = document.getElementById("from-location");

if (fromInput && fromResults) {
    new AirportCity(fromInput, fromResults);
}

const toInput = document.getElementById("landing-location");
const toResults = document.getElementById("to-location");

if (toInput && toResults) {
    new AirportCity(toInput, toResults);
}

const staysInputs = document.querySelectorAll(".visit-location");
staysInputs.forEach((staysInput) => {
    const nearestLocationHead = staysInput.closest(".location-head");
    if (nearestLocationHead) {
        const nearestStaysList =
            nearestLocationHead.querySelector(".visit-list");
        if (nearestStaysList) {
            new AirportCity(staysInput, nearestStaysList);
        }
    }
});
// Flight search results start

// Card Swap Start
function initializeCarousel() {
    const carouselItems = document.querySelectorAll(".carousel-item");

    carouselItems.forEach((item) => {
        item.addEventListener("click", () => {
            const isItem = item.closest(".carousel-item");

            if (!isItem || item.classList.contains("active")) {
                return;
            }
            updateCarousel(item);
        });
    });

    function updateCarousel(newActive) {
        const newActivePos = parseInt(newActive.dataset.pos);
        const newCon = newActive.dataset.con;
        const positions = [-2, -1, 0, 1, 2];

        carouselItems.forEach((item) => {
            const itemPos = parseInt(item.dataset.pos);
            item.dataset.pos = calculateNewPosition(
                itemPos,
                newActivePos,
                positions
            );
            item.classList.remove("active");
        });

        newActive.classList.add("active");

        let parenetSelect = document.querySelector(".continents");
        let niceSelect = parenetSelect.querySelector(".nice-select");
        let allOption = niceSelect.querySelectorAll(".option");
        allOption.forEach((newEl) => {
            newEl.classList.remove("selected");
            if (newCon === newEl.innerText) {
                niceSelect.querySelector(".current").innerText = newCon;
                newEl.classList.add("selected");
            }
        });
    }

    function calculateNewPosition(currentPos, newActivePos, positions) {
        const diff = currentPos - newActivePos;

        if (Math.abs(diff) > 2) {
            return -currentPos;
        }

        return positions[positions.indexOf(diff)];
    }

    $("select").niceSelect();
    let parenetSelect = document.querySelector(".continents");
    if (parenetSelect) {
        let niceSelect = parenetSelect.querySelector(".nice-select");
        let allOption = niceSelect.querySelectorAll(".option");
        allOption.forEach((el) => {
            el.addEventListener("click", function () {
                var newItem = document.querySelector(
                    `[data-con="${el.innerText}"]`
                );
                updateCarousel(newItem);
            });
        });
    }
}
initializeCarousel();

// Card Swap End

// Login Popup Start

var loginButton = document.querySelector(".login-link");
var passwordButton = document.querySelector(".login-password");
var signUpButton = document.querySelector(".signup-link");
var resetButton = document.querySelector(".otpRequest");
var loginTab = document.querySelector(".loginTab");
var signupTab = document.querySelector(".signupTab");
var conformationTab = document.querySelector(".conformationTab");
var otpTab = document.querySelector(".otpTab");

// Create a function to toggle the visibility of elements
function toggleTabVisibility(showTab, hideTabs) {
    showTab.classList.remove("d-none");
    for (var i = 0; i < hideTabs.length; i++) {
        hideTabs[i].classList.add("d-none");
    }
}

// Add event listeners for each button
loginButton.addEventListener("click", function () {
    toggleTabVisibility(loginTab, [signupTab, conformationTab, otpTab]);
});

passwordButton.addEventListener("click", function () {
    toggleTabVisibility(conformationTab, [loginTab, signupTab, otpTab]);
});

signUpButton.addEventListener("click", function () {
    toggleTabVisibility(signupTab, [loginTab, conformationTab, otpTab]);
});

resetButton.addEventListener("click", function () {
    toggleTabVisibility(otpTab, [conformationTab, loginTab, signupTab]);
});

// Login Popup End

// Travelers Option

var travelerToggle = document.querySelectorAll(".travelers-head");

travelerToggle.forEach((e) => {
    e.addEventListener("click", function () {
        var travelerBody = this.nextElementSibling; // Find the nearest .travelers-body
        travelerBody.classList.toggle("open");
    });
});

// Add an event listener to the document to listen for clicks outside of .travelers-head and .travelers-body
document.addEventListener("click", function (event) {
    var clickTarget = event.target;
    // Check if the click target is not within .travelers-head or .travelers-body
    if (
        !clickTarget.closest(".travelers-head") &&
        !clickTarget.closest(".travelers-body")
    ) {
        // Remove the "open" class from all .travelers-body elements
        var travelerBodies = document.querySelectorAll(".travelers-body");
        travelerBodies.forEach(function (body) {
            body.classList.remove("open");
        });
    }
});

// Traveler Option End

// Date Range Picker Start
$(document).ready(function () {
    var datePickers = document.querySelectorAll(".panel-body");

    datePickers.forEach(function (datePicker) {
        var $datePicker = $(datePicker);
        var $dateStart = $datePicker.find(".date-start");
        var $dateEnd = $datePicker.find(".date-end");

        $dateStart.daterangepicker(
            {
                autoApply: true,
                opens: "up",
                drops: "up",
                autoUpdateInput: false,
                parentEl: datePicker, // Initialize within the specific panel-body container
                locale: {
                    format: "DD-MM-YYYY",
                },
            },
            function (start, end) {
                var selectedStartDate = start.format("DD-MM-YYYY");
                var selectedEndDate = end.format("DD-MM-YYYY");

                $dateStart.val(selectedStartDate);
                $dateEnd.val(selectedEndDate);
            }
        );

        $dateEnd.on("click", function (e) {
            e.preventDefault();
            $dateStart.click();
        });
    });

    // Hotel View Date Picker
    if ($("#checkIn, #checkOut").length > 0) {
        var checkInInput = $("#checkIn");
        var checkOutInput = $("#checkOut");

        var pickerOptions = {
            autoApply: true,
            opens: "up",
            parentEl: ".travel-section",
            drops: "up",
            autoUpdateInput: false,
            locale: {
                format: "DD-MM-YYYY",
            },
        };

        checkInInput.daterangepicker(pickerOptions, function (start, end) {
            var selectedStartDate = start.format("DD-MM-YYYY");
            var selectedEndDate = end.format("DD-MM-YYYY");

            // Updating Fields with selected dates
            checkInInput.val(selectedStartDate);
            checkOutInput.val(selectedEndDate);
        });

        $("#checkOut").on("click", function (e) {
            e.preventDefault();
            checkInInput.data("daterangepicker").show();
        });
    }
    // Hotel View Date Picker End
});
// Date Range Picker End

// Traveler count funtion Start

function initializeTravelersCounter() {
    // Function to update the "travelers-content" element for a specific group
    function updateTravelersContent(inputElements, travelersContent) {
        let total = 0;

        inputElements.forEach((inputElement) => {
            total += parseInt(inputElement.value, 10);
        });

        if (total > 0) {
            travelersContent.textContent = `Travelers: ${total}`;
        } else {
            travelersContent.textContent = "0";
        }
    }

    // Get all the parent elements of each group of travelers
    const travelersGroups = document.querySelectorAll(".travelers");

    travelersGroups.forEach((group) => {
        // Get the input elements within the current travelers group
        const inputElements = group.querySelectorAll(".total-count");

        // Get the "travelers-content" element within the current travelers group
        const travelersContent = group.querySelector(".travelers-content");

        // Add input event listeners to input elements within the current group
        inputElements.forEach((inputElement) => {
            inputElement.addEventListener("input", () => {
                updateTravelersContent(inputElements, travelersContent);
            });
        });

        // Initial update of the "travelers-content" element for the current group
        updateTravelersContent(inputElements, travelersContent);
    });

    const counterButtons = document.querySelectorAll(".counter-button");

    counterButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const parent = button.closest(".travelers-item");
            if (!parent) {
                return;
            }

            const inputElement = parent.querySelector(".total-count");
            const currentValue = parseInt(inputElement.value, 10); // Parse current value as a decimal

            // Get the maximum value from the input's "max" attribute and parse it
            const max = parseInt(inputElement.getAttribute("max"));

            // Get the input elements and "travelers-content" for the current group
            const group = parent.closest(".travelers");
            const inputElements = group.querySelectorAll(".total-count");
            const travelersContent = group.querySelector(".travelers-content");

            if (button.classList.contains("minus")) {
                if (currentValue > 1) {
                    inputElement.value = currentValue - 1;
                }
            } else if (button.classList.contains("plus")) {
                if (currentValue < max) {
                    inputElement.value = currentValue + 1;
                }
            }

            // Check if the value is 1 and add the "disabled" class to the minus button
            if (parseInt(inputElement.value, 10) === 1) {
                parent
                    .querySelector(".counter-button.minus")
                    .classList.add("disabled");
            } else {
                parent
                    .querySelector(".counter-button.minus")
                    .classList.remove("disabled");
            }

            // Check if the value equals the maximum value and add the "disabled" class to the plus button
            if (parseInt(inputElement.value, 10) === max) {
                parent
                    .querySelector(".counter-button.plus")
                    .classList.add("disabled");
            } else {
                parent
                    .querySelector(".counter-button.plus")
                    .classList.remove("disabled");
            }

            // Update the travelers-content element for the current group
            updateTravelersContent(inputElements, travelersContent);
        });
    });

    // Initial update of the travelers-content elements for all groups
    travelersGroups.forEach((group) => {
        const inputElements = group.querySelectorAll(".total-count");
        const travelersContent = group.querySelector(".travelers-content");
        updateTravelersContent(inputElements, travelersContent);
    });
}
initializeTravelersCounter();

// Traveler count funtion End

// Flight Animation Start

const flightLoad = document.getElementById("get-flights");
const flightFound = document.getElementById("flights-found");
if (flightLoad && flightFound) {
    setTimeout(() => {
        flightLoad.classList.add("d-none");
        flightFound.classList.remove("d-none");
    }, 5000);
}

// Flight Animation End

// If you wish to write some custom code please place this file at the bottom.
import "./custom";
